var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBellIcon = function SvgBellIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.7V16.5H2.25V8.8C2.25 7.27833 2.71875 5.92625 3.65625 4.74375C4.59375 3.56125 5.8125 2.78667 7.3125 2.42V1.65C7.3125 1.19167 7.47656 0.802083 7.80469 0.48125C8.13281 0.160417 8.53125 0 9 0C9.46875 0 9.86719 0.160417 10.1953 0.48125C10.5234 0.802083 10.6875 1.19167 10.6875 1.65V2.42C12.1875 2.78667 13.4062 3.56125 14.3438 4.74375C15.2812 5.92625 15.75 7.27833 15.75 8.8V16.5H18V18.7H0ZM9 22C8.38125 22 7.85156 21.7846 7.41094 21.3538C6.97031 20.9229 6.75 20.405 6.75 19.8H11.25C11.25 20.405 11.0297 20.9229 10.5891 21.3538C10.1484 21.7846 9.61875 22 9 22Z",
    fill: "#E8EAED"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBellIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell-icon.932a7cfe.svg";
export { ForwardRef as ReactComponent };